import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader, InfoWindow  } from "@react-google-maps/api";
import { Grid, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const containerStyle = {
  width: "100%",
  height: "100vh",
};
const RiderTrack = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { latitude, longitude, vehicleNo } = state || {}; // destructure vehicleNo here
  
    const [showInfoWindow, setShowInfoWindow] = useState(false); // to toggle InfoWindow
  
    const handleBackToDashboard = () => {
      navigate("/evdetails/ev-details-list");
    };
  
    const { isLoaded } = useJsApiLoader({
      googleMapsApiKey: "AIzaSyAHzQG6CbgD3VdoChRyoYr8qbUm0ZRoBEg", // Replace with your key
    });
  
    const center = {
      lat: latitude,
      lng: longitude,
    };
  
    return isLoaded ? (
      <div className="flex bg-white min-h-80 box-shadow p-3 rounded-xl mx-16 mt-10">
        <div className="w-full">
          <Grid
            container
            spacing={5}
            className="w-full flex justify-between items-center"
          >
            <Grid item md={6}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                  <IconButton onClick={handleBackToDashboard}>
                    <ArrowBackIcon />
                  </IconButton>
                  Rider Current Location
                </h2>
              </div>
            </Grid>
          </Grid>
  
          <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
            <Marker
              position={center}
              onClick={() => setShowInfoWindow(true)}
            />
            {showInfoWindow && (
             <InfoWindow
             position={center}
             onCloseClick={() => setShowInfoWindow(false)}
           >
             <div>
               <p><strong>Vehicle No:</strong> {vehicleNo}</p>
               <p><strong>Latitude:</strong> {latitude}</p>
               <p><strong>Longitude:</strong> {longitude}</p>
               <a
                 href={`https://www.google.com/maps?q=${latitude},${longitude}`}
                 target="_blank"
                 rel="noopener noreferrer"
                 style={{
                   display: "inline-block",
                   marginTop: "8px",
                   backgroundColor: "#4285F4",
                   color: "white",
                   padding: "6px 12px",
                   borderRadius: "4px",
                   textDecoration: "none",
                   fontWeight: "bold",
                 }}
               >
                 Open in Google Maps
               </a>
             </div>
           </InfoWindow>
           
            )}
          </GoogleMap>
        </div>
      </div>
    ) : (
      <p>Loading...</p>
    );
  };
  
export default RiderTrack;
